import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const AboutPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, md: 8 } }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontSize: { xs: '2rem', md: '2.5rem' } }}>
          About
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: '1rem', md: '1.15rem' }, mb: 3 }}>
          Welcome to Digital StoreFront! We are dedicated to providing you with the best online shopping experience, offering a wide range of quality products at competitive prices. Our mission is to make shopping easy, secure, and enjoyable for everyone.
        </Typography>
        <Typography variant="h6" sx={{ mt: 4, mb: 1, fontSize: { xs: '1.15rem', md: '1.25rem' } }}>
          Why Shop With Us?
        </Typography>
        <Typography variant="body2" sx={{ fontSize: { xs: '0.97rem', md: '1.08rem' } }}>
          - Curated collection of top products<br/>
          - Fast and reliable delivery<br/>
          - Secure payment options<br/>
          - Friendly customer support
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutPage;
